define('views/pages/organization/markers/index',['require','jquery','mediator','views/base/view','models/base/modal','views/base/modal','views/base/form','views/pages/organization/markers/navbar','views/pages/organization/markers/table','text!templates/pages/organization/markers/index.ejs','text!templates/pages/organization/markers/addMarkerModal.ejs','views/demo-dialog'],function(require) {
    'use strict';

    var $ = require('jquery'),
        mediator = require('mediator'),
        View = require('views/base/view'),
        ModalModel = require('models/base/modal'),
        ModalView = require('views/base/modal'),
        FormView = require('views/base/form'),
        OrganizationMarkersNavbarView = require('views/pages/organization/markers/navbar'),
        OrganizationMarkersTableView = require('views/pages/organization/markers/table'),
        template = require('text!templates/pages/organization/markers/index.ejs'),
        templateAddMarkerModal = require('text!templates/pages/organization/markers/addMarkerModal.ejs'),
        DemoDialog = require('views/demo-dialog');

    var ModalContentView = FormView.extend({
        autoRender: true,
        template: templateAddMarkerModal
    });

    var OrganizationMarkersView = View.extend({
        autoRender: true,
        template: template,
        region: 'organization-markers-tab',
        regions: {
            'organization-markers-table': '#organization-markers-table-container',
            'organization-markers-navbar': '#organization-markers-navbar-container'
        },
        listen: {
            'afterLoad model': 'render',
            'activate model': 'onActivate',
            'add model': 'onAddMarker',
            'edit model': 'onEditMarker',
            'delete model': 'onDeleteMarker',
            'delete model.markers': 'onDeleteMarker'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
        },
        render: function() {
            View.prototype.render.apply(this, arguments);
            this.subview('navbar', new OrganizationMarkersNavbarView({ model: this.model }));
            this.subview('table', new OrganizationMarkersTableView({ collection: this.model.markers, model: this.model }));
        },
        onActivate: function() {
            mediator.setBreadcrumb(['organization'], 'Маркеры');
            this.model.load(true);
        },
        onAddMarker: function(){
            var modalModel = new ModalModel({
                title: 'Добавление маркера',
                buttons: [
                    { caption: 'Закрыть', className: '', 'action': 'cancel' },
                    { caption: 'Добавить', className: 'btn-success', 'action': 'add' }
                ]
            });

            var _this = this;

            var MarkerModel = this.model.markers.model;

            var contentModel = new MarkerModel({
                errors: {}
            });

            var modalView = new ModalView({ model: modalModel });
            var contentView = new ModalContentView({ model: contentModel, region: 'modal-content' });

            modalView.subview('content', contentView);

            modalModel.on('action', function(action, cancel) {
                if (action === 'add') {
                    contentView.showLoader();
                    contentView.disableActions();
                    modalView.disableButtons();

                    $('.error', contentView.$el).hide();

                    var valid = contentModel.save(null, {
                        success: function() {
                            _this.model.markers.add(contentModel);
                            modalView.dispose();
                        },
                        error: function(model, resp) {
                            console.log('ADD ERROR', resp.responseJSON);
                            contentModel.set('errors', resp.responseJSON.error || { global: 'Ошибка при создании записи' });
                            contentView.render();
                            modalView.enableButtons();

                        }
                    });
                    if (!valid) {
                        contentModel.set('errors', contentModel.validationError);
                        contentView.render();
                        modalView.enableButtons();
                    }
                    cancel();
                }
            });

        },

        onEditMarker: function() {
            var selected = this.model.get('selected');

            if (!selected) {
                return;
            }

            var modalModel = new ModalModel({
                title: 'Радактирование маркера',
                buttons: [
                    { caption: 'Закрыть', className: '', 'action': 'cancel' },
                    { caption: 'Сохранить', className: 'btn-success', 'action': 'save' }
                ]
            });

            var contentModel = selected.clone();
            contentModel.set('errors', {});
            var modalView = new ModalView({ model: modalModel });
            var contentView = new ModalContentView({ model: contentModel, region: 'modal-content' });

            modalView.subview('content', contentView);

            modalModel.on('action', function(action, cancel) {
                if (action === 'save') {
                    contentView.showLoader();
                    contentView.disableActions();
                    modalView.disableButtons();

                    $('.error', contentView.$el).hide();

                    var valid = contentModel.save(null, {
                        success: function() {
                            selected.set(contentModel.getAttributes());
                            modalView.dispose();
                        },
                        error: function(model, resp) {
                            contentModel.set('errors', resp.responseJSON.messages || { global: 'Ошибка при создании записи' });
                            contentView.render();
                            modalView.enableButtons();

                        }
                    });
                    if (!valid) {
                        contentModel.set('errors', contentModel.validationError);
                        contentView.render();
                        modalView.enableButtons();
                    }
                    cancel();
                }
            });
        },

        onDeleteMarker: function() {
            if (DemoDialog.isDemo()) { return DemoDialog.show(); }

            var selected = this.model.get('selected');

            if (!selected) { return; }

            var modalModel = new ModalModel({
                'title': 'Удаление маркера',
                'buttons': [
                    { caption: 'Да', className: 'btn-danger', 'action': 'submit' },
                    { caption: 'Нет', className: '', 'action': 'cancel' }
                ],
                body: '<h4>Вы действительно хотите удалить маркер ' + selected.get('Code') + ' ?</h4>',
                errors: {}
            });

            var modalView = new ModalView({ model: modalModel });
            this.subview('modal', modalView);

            modalModel.on('action', function(action, cancel) {
                if (action === 'submit') {
                    modalView.disableButtons();
                    selected.destroy({
                        wait: true,
                        success: function() {
                            modalView.dispose();
                        },
                        error: function() {
                            modalModel.set({
                                body: '<div class="alert alert-danger">Ошибка при удалении записи </div>',
                                buttons: [{ caption: 'Закрыть', className: '', 'action': 'cancel' }]
                            });
                            modalView.render();
                            modalView.enableButtons();
                        }
                    });

                    cancel();
                }
            });
        }
    });

    return OrganizationMarkersView;
});


